import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root'
})
export class TerritorioService {

  constructor(
    private gqlclient: GraphQLClient
  ) { }

  obtenerCombo(inputParams: {
    entidad: {
      empresa_rut: number,
      sucursal_codigo: number,
      tipobusqueda: number
    }
  }, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: territorioInputType) {
          territorio {
            obtenerSegunFiltro(filtro: {exacto: $entidad}, paginaActual: 1, cantidadRegistrosPorPagina: -1) {
              mensajes {
                tipo
                texto
                codigo
                contexto
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  codigo
                  descripcion
                  sucursal_codigo
                  empresa_rut
                  estado
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.territorio.obtenerSegunFiltro
        callback({ mensajes, respuesta })
      }
    );
  }

  obtenerReporteVentasTerritoriosResumen(inputParams: {
    entidad: {
      empresa_rut: number
      sucursal_codigo: number
      fecha_desde: Date
      fecha_hasta: Date
      listaTerritorio: any[]
      listaRubro: any[]
      listaFamilia: any[]
    },
    paginaActual: number
    cantidadRegistrosPorPagina: number
  }, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: territorioInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          territorio {
            obtenerReporteVentasTerritoriosResumen(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                contexto
                texto
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  empresa_rut
                  sucursal_codigo
                  nombre
                  monto_neto
                  descuento
                  neto_total
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.territorio.obtenerReporteVentasTerritoriosResumen
        callback({ mensajes, respuesta })
      }
    );
  }

  obtenerReporteVentasTerritoriosResumenExcel(inputParams: {
    entidad: {
      empresa_rut: number
      sucursal_codigo: number
      fecha_desde: Date
      fecha_hasta: Date
      listaTerritorio: any[]
      listaRubro: any[]
      listaFamilia: any[]
    },
    paginaActual: number
    cantidadRegistrosPorPagina: number
  }, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: territorioInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          territorio {
            obtenerReporteVentasTerritoriosResumen(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                registros {
                  rutaArchivo
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.territorio.obtenerReporteVentasTerritoriosResumen
        callback({ mensajes, respuesta })
      }
    );
  }

  obtenerReporteVentasTerritoriosDetalle(inputParams: {
    entidad: {
      empresa_rut: number
      sucursal_codigo: number
      fecha_desde: Date
      fecha_hasta: Date
      listaTerritorio: any[]
      listaRubro: any[]
      listaFamilia: any[]
    },
    paginaActual: number
    cantidadRegistrosPorPagina: number
  }, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: territorioInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          territorio {
            obtenerReporteVentasTerritoriosDetalle(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                contexto
                texto
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  empresa_rut
                  sucursal_codigo
                  nombre
                  monto_neto
                  descuento
                  neto_total
                  tipo_dte_codigo
                  tipo_dte_nombre
                  folio
                  cliente_proveedor_rut
                  cliente_proveedor_nombre
                  direccion_codigo
                  direccion_nombre
                  nombrecomuna
                  codigo
                  monto_neto
                  descuento
                  neto_total
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.territorio.obtenerReporteVentasTerritoriosDetalle
        callback({ mensajes, respuesta })
      }
    );
  }

  obtenerReporteVentasTerritoriosDetalleExcel(inputParams: {
    entidad: {
      empresa_rut: number
      sucursal_codigo: number
      fecha_desde: Date
      fecha_hasta: Date
      listaTerritorio: any[]
      listaRubro: any[]
      listaFamilia: any[]
    },
    paginaActual: number
    cantidadRegistrosPorPagina: number
  }, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: territorioInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          territorio {
            obtenerReporteVentasTerritoriosDetalle(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                registros {
                  rutaArchivo
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.territorio.obtenerReporteVentasTerritoriosDetalle
        callback({ mensajes, respuesta })
      }
    );
  }

  obtenerReporteTerritorioAnualizados(inputParams: {
    entidad: {
      empresa_rut: number
      sucursal_codigo: number
      listaTerritorio: any[]
      anno: number
    }
    paginaActual: number
    cantidadRegistrosPorPagina: number
  }, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: territorioInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          territorio {
            obtenerReporteTerritorioAnualizados(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                contexto
                texto
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  empresa_rut
                  sucursal_codigo
                  codigo
                  nombre
                  enero
                  febrero
                  marzo
                  abrir
                  mayo
                  junio
                  julio
                  agosto
                  septiembre
                  octubre
                  noviembre
                  diciembre
                  acumulado
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.territorio.obtenerReporteTerritorioAnualizados
        callback({ mensajes, respuesta })
      }
    );
  }

  obtenerReporteTerritorioAnualizadosExcel(inputParams: {
    entidad: {
      empresa_rut: number
      sucursal_codigo: number
      listaTerritorio: any[]
      anno: number
      retornaExcel: true // necessary
    }
  }, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: territorioInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          territorio {
            obtenerReporteTerritorioAnualizados(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                contexto
                texto
              }
              respuesta {
                registros {
                  rutaArchivo
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.territorio.obtenerReporteTerritorioAnualizados
        callback({ mensajes, respuesta })
      }
    );
  }

}
